export default {
  bank_nav_bar_title: "添加銀行卡",
  bank_card_info: "銀行卡資訊",
  bank_p_card_info: "請輸入個人真是銀行帳號",
  bank_bank: "銀行",
  bank_s_bank: "請選擇銀行",
  bank_account_type: "帳戶類型",
  bank_account: "帳號",
  bank_card_num: "卡號",
  bank_card_p_account: "請輸入銀行帳號",
  bank_card_p_num: "請輸入銀行卡號",
  bank_submit_btn: "新增",
  bank_submit_toast: "新增成功",
  select_bank_nav_title: "選擇銀行卡",
  select_bank_add_bank: "新增銀行卡",
  select_bank_popup_title: "確認申請",
  select_bank_popup_msg: "是否有提交貸款申請",
  select_bank_submit_toast: "申請成功"
}